import RolesView from '../views/pages/settings/roles/RolesView.vue'
import { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/settings/roles',
        name: 'settings-roles',
        component: RolesView,
        meta: {
            requiresAuth: true,
            subNavType: 'ACCOUNT_SETTINGS'
        }
    },
];

export default routes;